<template>
  <div class="group">
    <h5 class="group__title">{{ group.name }}</h5>
    <section
      v-for="topic in group.content"
      class="group__topic-wrapper"
      :key="`group-${topic.name}`"
    >
      <Topic
        class="group__topic"
        :isUser="isUser"
        :topicTitle="topic.name"
        :topicProgress="getTopicProgress(topic)"
        :topicContent="topic.content"
      />
      <Levels :leaves="topic.content" :progress="progress" />
    </section>
  </div>
</template>

<script>
import Topic from '@/components/course/content/Topic.vue'
import Levels from '@/components/course/content/Levels.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'Group',
  components: {
    Topic,
    Levels,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    isUser: {
      type: Boolean,
      required: true,
    },
    progress: {
      type: [Object, String],
      required: false,
    },
    currentVideos: {
      type: Array,
      required: true,
    },
    currentQuizzes: {
      type: Array,
      required: true,
    },
    currentExercises: {
      type: Array,
      required: true,
    },
    currentLabs: {
      type: Array,
      required: true,
    },
    currentIFrames: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getCurrentContent({ type, uuid }) {
      switch (type) {
        case 'video':
          return this.currentVideos.find(video => video.id === uuid)
        case 'quiz':
          return this.currentQuizzes.find(quiz => quiz.id === uuid)
        case 'exercise':
          return this.currentExercises.find(exercise => exercise.id === uuid)
        case 'lab':
          return this.currentLabs.find(lab => lab.id === uuid)
        case 'iframe':
          return this.currentIFrames.find(iframe => iframe.id === uuid)
        default:
          return { user_status: CONSTANTS.CONTENT_USER_STATUS.UNSTARTED }
      }
    },
    getTopicProgress(topic) {
      const progress = { total: topic.content.length, completed: 0 }
      if (this.isUser) {
        topic.content.map(level => {
          const { content_type: type, uuid } = level
          const current = this.getCurrentContent({ type, uuid })
          if (current) {
            const { user_status } = current
            if (
              user_status &&
              user_status === CONSTANTS.CONTENT_USER_STATUS.FINISHED
            )
              progress.completed += 1
          }
        })
      }
      return progress
    },
  },
}
</script>

<style lang="scss" scoped>
.group {
  &__title {
    font-size: 2rem;
    color: var(--white);
    margin-bottom: 30px;
    font-family: var(--font-bold);
  }
  &__topic-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 100px;
  }
  &__level-wrapper {
    border-left: 1px solid var(--light-gray);
    width: 100%;
    @include tablet {
      width: 75%;
    }
  }
  &__topic-quiz-wrapper {
    margin: 0 0 0 auto;
  }
}
</style>
